export default class Stripe {
	constructor(pricing, payment_type, content, sce, stripe) {
		this.publish_key 	= stripe.publish_key;
		this.secret_key 	= stripe.secret_key;
		this.stripeActive 	= false;
		this.pricing 		= pricing;
		this.stripe;
		this.paymentRequest;
		this.paymentDetails;
		
		this.content = content;
		
		console.log('Pricing - ', this.pricing);
		
		this.form_elements = ['number', 'expiry', 'cvc'];
		this.brand = 'unknown';
		this.creditCards = {
			'unknown'		: 'cc-unknown',
			'visa' 			: 'cc-visa-2',
			'mastercard'	: 'cc-mastercard-2',
			'amex'			: 'cc-amex',
			'jcb'			: 'cc-jcb',
			'discover'		: 'cc-discover',
			'diners'		: 'cc-diners-club'
		};
	}
	
	setup_payment_details(stripe, paymentRequest, paymentDetails) {
		this.stripe 		= stripe;
		this.paymentRequest = paymentRequest;
		this.paymentDetails = paymentDetails;
		
		var style 			= this.style(),
			elements 		= this.stripe.elements(),
			form_elements 	= this.form_elements,
			prButton 		= elements.create('paymentRequestButton', {paymentRequest: paymentRequest}),
			form 			= $('#stripe-payment');
			
		form_elements['number'] = elements.create('cardNumber', {style: style, hideIcon: false, iconStyle: 'solid', placeholder: this.content['billing-setup-card-number']}),
		form_elements['expiry'] = elements.create('cardExpiry', {style: style, placeholder: this.content['billing-setup-card-expiry']}),
		form_elements['cvc'] 	= elements.create('cardCvc', {style: style, placeholder: 'CVC'}),
		//postcode 	= elements.create('postalCode', {style: style, placeholder: this.content['billing-setup-postcode']}),

		form_elements['number'].mount('#card-element');
		form_elements['expiry'].mount('#card-expiry');
		form_elements['cvc'].mount('#card-cvc');
		//postcode.mount('#postcode');
		
		this.stripeActive = true;
		
		this.onCardNumberChange(form_elements['number']);
	}
	
	makePayment(token_id) {
		console.log('PRICE - ', this.pricing);
		
		var form 			= $('#stripe-payment'),
			action 			= form.attr('action'),
			paymentDetails 	= this.paymentDetails,
			source 			= 'tok_' + this.brand,
			pricing 		= this.pricing,
			amount 			= pricing.price.join();
			
		paymentDetails.total.label = this.pricing.type;
		paymentDetails.total.amount = amount.replace(',', '');
				
		return new Promise((resolve, reject)=> {
			var post_data = {
				token 	: token_id, 
				source	: source, 
				details : paymentDetails, 
				pricing : pricing
			};
			
			$.post(action, post_data, function(response){
				resolve(response);
			});
		});
	}
	
	formOnSubmit() {
		var that 			= this,
			form_elements 	= this.form_elements,
			form 			= $('#stripe-payment');

		return new Promise((resolve, reject)=> {
			this.stripe.createToken(form_elements['number']).then(function(result){
				if (result.error) {
					var errorElement = document.getElementById('card-errors');
				} else {
					that.tokenHandler(result.token).then((value)=>{
						resolve(value.token_id);
					});
				}
			});
		});
	}

	tokenHandler(token) {
		// Insert the token ID into the form so it gets submitted to the server
		var form = $('#stripe-payment');
		var hiddenInput = document.createElement('input');
		
		return new Promise((resolve, reject)=> {
			hiddenInput.setAttribute('type', 'hidden');
			hiddenInput.setAttribute('name', 'stripeToken');
			hiddenInput.setAttribute('value', token.id);

			form.append(hiddenInput);
			
			resolve({token_id: token.id});
		});
	}

	onCardNumberChange(number) {
		var that = this;
		
		number.addEventListener('change', function(event){
			//console.log('Card is changing - ', event);
			//console.log('card brand - ', event.brand);

			var brand 	= event.brand,
				svg 	= $('svg.credit-cards');

			that.brand = brand;

			if (svg.attr('class').indexOf(that.creditCards[brand]) === -1) {
				svg.animate({
					opacity: 0,
				}, 100, function(){
					svg.attr('class', 'credit-cards');
					svg.addClass(that.creditCards[brand]);
					
					$('svg.credit-cards use').attr('xlink:href', '#' + that.creditCards[brand]);
					svg.animate({
						opacity: 1
					}, 100);
				});
			} else {
				svg.attr('class', 'credit-cards');
				svg.addClass(that.creditCards[brand]);
			}
		});
	}
	
	onCardConfirmPayment(confirmBtn) {
		confirmBtn.addEventListener('click', function(e){
			console.log('Payment Button Clicked - ', e);
		});
	}

	style() {
		return {
			base: {
				fontFamily		: '"Roboto", sans-serif',
				fontWeight		: '300',
				fontSmoothing	: 'antialiased',
				fontSize		: '20px'
			}
		};
	}
}